<template>
    <div class="col text-center">
      <h5>{{title}}</h5>
      <div class="mt-3 btn-group-toggle d-inline-flex justify-content-center flex-wrap" data-toggle="buttons">
        <label
          v-for='staticB in static_buttons'
          :key='staticB.name'
          class="btn btn-secondary btn-toggle m-1"
        >
          <input type="checkbox" :value="staticB.id" :name="`${filter_name}[]`">{{staticB.name}}
        </label>
        <span v-if="expanded" class="btn-group-toggle d-contents" id="collapse_span">
          <label
            v-for='filter in filters'
            :key='filter.name'
            class="btn btn-secondary btn-toggle m-1"
          >
            <input type="checkbox" :value="filter.id" :name="`${filter_name}[]`">{{filter.name}}
          </label>
          <button v-if="expanded" @click='toggle_filters' class="btnToggle m-1" id="minus_button">
            -
          </button>
        </span>
        <div class="d-inline-flex">
          <button v-if="!expanded && !all_filters" @click='toggle_filters' class="btnToggle m-1" id="plus_button">
            +
          </button>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'forms-toggle-filters-vue',
    props: {
      visible_keys: { type: Array, default: () => []},
      filters: { type: Array, default: () => []},
      title: { type: String, default: '' },
      filter_name: { type: String, default: '' }
    },
    data() {
      return {
        expanded: false
      }
    },
    computed: {
      static_buttons() {
        let static_buttons = []
        this.visible_keys.forEach((key) => {
          let position = this.filters.findIndex(btn => btn.id == key.toString())
          if(position != -1) {
            static_buttons.push(this.filters.splice(position, 1)[0])
          }
        })
        return static_buttons
      },
      all_filters() {
        return this.filters.every(filter => this.visible_keys.includes(filter))
      }
    },
    methods: {
      toggle_filters() {
        this.expanded = !this.expanded
      }
    }

  }
</script>

